import { useState, useEffect } from "react";
import { createModule, getModules } from "../../services/adminService";
import toast from "react-hot-toast";

export default function CreateModule() {
  const [name, setName] = useState("");
  const [status, setStatus] = useState("1"); // default enabled
  const [modules, setModules] = useState([]);

  useEffect(() => {
    fetchModules();
  }, []);

  const fetchModules = async () => {
    const res = await getModules();
    setModules(Array.isArray(res.data.data) ? res.data.data : []);
  };

  const submit = async (e) => {
    e.preventDefault();

    const trimmedName = name.trim();

    if (!trimmedName) return toast.error("Module required");

    const exists = modules.some(
      (module) =>
        module.name.toLowerCase() === trimmedName.toLowerCase()
    );

    if (exists) return toast.error("Module already exists");

    try {
      await createModule({
        name: trimmedName,
        status: Number(status), // send 1 or 0
      });

      toast.success("Module created");
      setName("");
      setStatus("1");
      fetchModules();
    } catch (error) {
      console.log(error.response);

      if (error.response?.status === 422) {
        toast.error(error.response.data.message || "Validation failed");
      } else {
        toast.error("Something went wrong");
      }
    }
  };

  return (
    <form className="max-w-md bg-white p-6 rounded-xl shadow" onSubmit={submit}>
      {/* Module Name */}
      <input
        className="w-full border p-3 rounded mb-3"
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder="Module name"
      />

      {/* Status Dropdown */}
      <select
        className="w-full border p-3 rounded"
        value={status}
        onChange={(e) => setStatus(e.target.value)}
      >
        <option value="1">Enable</option>
        <option value="0">Disable</option>
      </select>

      {/* Submit */}
      <button className="mt-4 bg-blue-600 text-white px-4 py-2 rounded">
        Save
      </button>
    </form>
  );
}